export const CanvasSVGObjectContentType = {
  StickyNote: 'StickyNote',
  Link: 'Link',
  Whiteboard: 'Whiteboard',
};
